module.exports = __webpack_public_path__ + "feedbackmodule/img/logo_eu.42b776cf.png";